import type React from "react";
import { Box } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StorageIcon from "@mui/icons-material/Storage";
import ShowArticleStockLocationProperties from "./ShowArticleStockLocationProperties";
import { useStyles } from "./ShowArticleStockLocation.style";
import ArticleStockLocationType from "../../../entities/ArticleStockLocationType";

const ShowArticleStockLocation: React.FC<
  ShowArticleStockLocationProperties
> = ({ location, className = "" }) => {
  const classes = useStyles();

  const getLocationInfo = () => {
    switch (location) {
      case ArticleStockLocationType.DELIVERY_PERSON:
        return {
          text: "Con Repartidor",
          icon: <LocalShippingIcon sx={{ fontSize: "20px" }} />,
        };
      case ArticleStockLocationType.WAREHOUSE:
        return {
          text: "En Almacén",
          icon: <StorageIcon sx={{ fontSize: "20px" }} />,
        };
      default:
        return {
          text: "Localización Desconocida",
          icon: <StorageIcon sx={{ fontSize: "20px" }} />,
        };
    }
  };

  const locationInfo = getLocationInfo();

  return (
    <Box className={className}>
      <div className={classes.title}>{"Localización"}</div>

      <div className={classes.location_container}>
        {locationInfo.icon}
        <div className={classes.text}>
          {locationInfo.text}
        </div>
      </div>
    </Box>
  );
};

export default ShowArticleStockLocation;
